<template>
    <network-graph :topicId="20417" height="310" width="800" :title="tx.TitleNet"></network-graph>
</template>

<script>
    import networkGraph from "./widgets/statistics/networkGraph.vue"
    export default {
        name: "TopicNetwork",
        components: {
            networkGraph,
        },
        data() {
            return {
                tx: {
                    TitleNet: this.$LanguageProvider.GetResource("TitleNet", "Caption", "Netzwerk"),
                }
            }
        }
    };
</script>



<style>
</style>